import { Button } from '@design-system';
import React from 'react';

import { DialogContainer } from './DialogShared';
import { Modal } from './Modal';
import { DialogBaseProps } from './types';

export interface SimpleDialogProps extends DialogBaseProps {
  centered?: boolean;
}

export const SimpleDialog: React.FC<
  React.PropsWithChildren<SimpleDialogProps>
> = (props) => {
  const { centered, children, onClose, open, title } = props;

  return (
    <Modal
      dismissible
      onClose={onClose}
      open={open}
      title={title}
      verticalAlign="center"
    >
      <DialogContainer centered={centered}>
        <div className="p-6 pb-0">
          <div className="flex items-center justify-between pb-4 pt-4 md:pb-4 md:pt-0">
            <div />
            <p className="text-balance text-center text-sm font-bold md:text-md">
              {title}
            </p>
            <Button
              hideLabel
              icon="ic_close"
              label="Close"
              onClick={onClose}
              size="sm"
              variant="transparent"
            />
          </div>
        </div>

        <div className="overflow-y-scroll no-scrollbar">
          <div className="p-6 pt-0">{children}</div>
        </div>
      </DialogContainer>
    </Modal>
  );
};
